import SignUpView from "@/components/templates/Signup/SignupView";
import UserConfirm from "@/components/templates/Signup/UserConfirm";
import UserVerify from "@/components/templates/Signup/UserVerify";
import { Locales } from "@/lib/i18n";
import { actions, segments } from "@/locales/segment";

export const getActionFromSlug = (locale: Locales, slug: string) => {
  const localeActions = actions[locale as keyof typeof actions];
  if (!localeActions) return null;
  return Object.keys(localeActions).find((key) => localeActions[key] === slug);
};

export const isSignupSegment = (locale: Locales, slug: string) => {
  const localeSegments = segments[locale as keyof typeof segments];
  if (!localeSegments) return false;
  return localeSegments.signup === slug;
};

export const renderSignupView = (resolution: Resolution) => {
  const slugs = resolution.slugs;
  const currentSlug = slugs[0];

  if (isSignupSegment(resolution.locale, currentSlug)) {
    return <SignUpView resolution={resolution} />;
  }

  const action = getActionFromSlug(resolution.locale, currentSlug);

  if (!action) {
    return null;
  }

  switch (action) {
    case "verify":
      return <UserVerify resolution={resolution} />;
    case "confirm":
      return <UserConfirm resolution={resolution} />;
    default:
      return null;
  }
};
